/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PolicyEditor_documentSave$ref: FragmentReference;
export type PolicyEditor_documentSave = {|
  +pk: ?number,
  +savedCopy: ?{|
    +pk: ?number,
    +author: {|
      +pk: ?number,
      +firstName: string,
      +lastName: string,
      +email: string,
    |},
    +isTemplate: ?boolean,
    +usersNotificationComment: ?{|
      +usersNotificationCommentOn: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +firstName: string,
        +lastName: string,
      |}>,
      +usersNotificationCommentOff: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +firstName: string,
        +lastName: string,
      |}>,
    |},
  |},
  +$refType: PolicyEditor_documentSave$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v3 = [
  v0,
  v1,
  v2
];
return {
  "kind": "Fragment",
  "name": "PolicyEditor_documentSave",
  "type": "DocumentSaveType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "savedCopy",
      "storageKey": null,
      "args": null,
      "concreteType": "RLDatixDocumentType",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "author",
          "storageKey": null,
          "args": null,
          "concreteType": "UserType",
          "plural": false,
          "selections": [
            v0,
            v1,
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "email",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isTemplate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "usersNotificationComment",
          "storageKey": null,
          "args": null,
          "concreteType": "UserCommentNotificationType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "usersNotificationCommentOn",
              "storageKey": null,
              "args": null,
              "concreteType": "UserType",
              "plural": true,
              "selections": v3
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "usersNotificationCommentOff",
              "storageKey": null,
              "args": null,
              "concreteType": "UserType",
              "plural": true,
              "selections": v3
            }
          ]
        }
      ]
    }
  ]
};
})();

(node/*: any*/).hash = 'b58cf8a70572b1397d783de449557777';
module.exports = node;
